import * as XLSX from "xlsx";
import {saveWorkbook} from "../../../utils/excel";
import {PERMISSION_LABEL_MAPPING, ROLES} from "../../../utils/constants";

const HEADER = ['姓名/名稱', '貼心到宅角色', '權限', 'EMAIL', '所屬業務組別']

const computePermissionString = (permissions) => {
  if (!permissions) return '';

  const permissionList = Object.keys(permissions)
    .map((permission) => {
      return (permissions[permission]) ? PERMISSION_LABEL_MAPPING[permission] : ''
    })
    .filter(permission => permission !== '')
  return permissionList.join(', ');
}

export const useExportUserManagement = ({
  data,
}) => {
  const exportData = () => {
    const workbook = XLSX.utils.book_new();
    const values = []

    values.push(HEADER)
    for (const row of data){
      const role = ROLES.find((r) => r.value === row.role);
      values.push([
        row.name,
        role.label,
        computePermissionString(row.permissions),
        row.email,
        row.organization,
      ])
    }

    const worksheet = XLSX.utils.aoa_to_sheet(values);
    XLSX.utils.book_append_sheet(workbook, worksheet, '總表');
    saveWorkbook({ workbook, fileName: '貼心到宅帳號列表'})
  }
  return { exportData }
}